export const Message = ({ data }) => {
  return (
    <div class="message">
      <div class="container">
        <div class={data.severity || "warning"}>
          <span>{data.message}</span>
        </div>
      </div>
    </div>
  )
}
